<template lang="pug">
  .form-item
    v-card.px-3.pb-3(style="border-radius:0px")
      v-row(align="center")
        v-col.pb-1.mt-n1
          p.mb-0.font-weight-bold.subtitle-1.pr-0 {{ page.title }}
        v-col.pb-1.pt-0.mt-2.pr-0(cols="5")
          v-layout
            v-spacer
            v-btn(icon @click="clickShare" small)
              v-icon(color="primary" size="23") mdi-export-variant
            v-menu(left :offset-y='true')
              template(v-slot:activator='{ on }')
                v-btn.mx-3(icon v-on="on" small)
                  v-icon(size="26") mdi-dots-vertical
              v-list
                v-list-item( @click="clickView")
                  v-list-item-title.font-weight-bold {{ $t('view_page') }}
                v-list-item(@click="clickEdit")
                  v-list-item-title {{ ['Admin'].includes(member.role) ? 'Edit' : 'Custom Link'}}
                v-list-item(v-if="['Admin'].includes(member.role)" @click="clickDelete")
                  v-list-item-title.grey--text {{ $t('delete') }}
            y-switch.my-0(v-if="member.role === 'Admin'" v-model="status")

      v-layout.pt-0
        p.body-2.grey--text.text--darken-1.mb-0 {{ $t('page_views') }}: {{ pageViews }}

    .modals
      add-yezza-page(v-if="showAddWaFormDialog" :open.sync="showAddWaFormDialog" :page.sync="page" :company="company")
      y-dialog(v-model='openDeleteDialog', max-width='290')
        v-card
          v-card-title.title {{ $t('delete_page') }}
          v-card-text
            | {{ $t('delete_page_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='grey' text @click='openDeleteDialog = false')
              | {{ $t('cancel') }}
            v-btn(color='red' text @click='startDelete' :loading="isLoading")
              | {{ $t('delete') }}

      y-bottom-sheet(v-model='shareSheet' inset)
        v-list
          v-subheader {{ $t('share_url_by') }}
          v-list-item(@click="shareUrlToSocial('whatsapp')")
            v-list-item-avatar
              v-icon(color="green") fab fa-whatsapp
            v-list-item-title WhatsApp
          v-list-item(@click="shareUrlToSocial('facebook')")
            v-list-item-avatar
              v-icon(color="#3b5998") fab fa-facebook
            v-list-item-title Facebook
          v-list-item(@click="copyUrl" v-clipboard:copy="getFormURL()")
            v-list-item-avatar
              v-icon mdi-content-copy
            v-list-item-title {{ $t('copy_link') }}

</template>

<script>
import { mapActions, mapState } from 'vuex'
import AddYezzaPage from '@/components/dialogs/AddYezzaPage.vue'

export default {
  name: 'YezzaStorePageItem',
  props: ['parentPage', 'company'],
  components: { AddYezzaPage },
  data: () => ({
    openDeleteDialog: false,
    showAddWaFormDialog: false,
    showSortProductDialog: false,
    showDuplicateFormDialog: false,
    shareSheet: false,
    isLoading: false,
    pageViews: 0,
  }),
  computed: {
    ...mapState('user', ['member']),
    page: {
      get() {
        return this.parentPage
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    },
    status: {
      set (val) {
        this.updateForm(val)
      },
      get () {
        if (this.page.status === 'published') {
          return true
        } else {
          return false
        }
      }
    }
  },
  mounted () {
    this.axios.get(`/store/settings/${this.company.slug}/pages/${this.page.slug}/analytics`)
      .then((response) => {
        this.pageViews = response.data.total_page_views
      })
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getFormURL () {
      return `https://${this.company.slug}.${process.env.VUE_APP_STORE_URL_DOMAIN}/${this.page.slug}`
    },
    getShareLinkURL () {
      return `WhatsApp Now: https://${this.company.slug}.${process.env.VUE_APP_STORE_URL_DOMAIN}/${this.page.slug}`
    },
    getShareLinkFB () {
      return `https://${this.company.slug}.${process.env.VUE_APP_STORE_URL_DOMAIN}/${this.page.slug}`
    },
    getShortLinkURL () {
      return `WhatsApp Now: https://${process.env.VUE_APP_STORE_URL_DOMAIN}/${this.page.slug}`
    },
    getQRLinkURL () {
      return `https://${process.env.VUE_APP_STORE_URL_DOMAIN}/${this.page.slug}`
    },
    getShareCustomURL () {
      return `WhatsApp Now: ${this.customlink}`
    },
    clickEdit () {
      this.$router.push({ name: 'AddYezzaStorePage', params: { page: this.page }})
      // this.showAddWaFormDialog = true
    },
    clickDelete () {
      this.openDeleteDialog = true
    },
    clickShare () {
      this.shareSheet = true
    },
    shareUrlToSocial(platform) {
      console.log(platform)
      if (platform == 'whatsapp') {
        window.open(`https://api.whatsapp.com/send?text=${this.getShareLinkURL()}`, '_blank')
      } else if (platform == 'facebook') {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.getShareLinkFB()}`, '_blank')
      } else if (platform === 'twitter' ) {
        window.open(`http://twitter.com/share?url=${encodeURIComponent(this.getShareLinkURL())}`, '_blank')
      }
    },
    copyUrl() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
      this.shareSheet = false
    },
    clickView () {
      window.open(`${this.getFormURL()}/?preview=true`)
    },
    startDelete() {
      this.isLoading = true
      this.axios.delete(`/store/settings/${this.company.slug}/pages/${this.page.slug}/`)
        .then(() => {
          this.$emit('deleted', this.page)
          this.openDeleteDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateForm (val) {
      let status = ''
      let word = ''
      if (val) {
        status = 'published'
        word = 'Page published successfully.'
      } else {
        status = 'draft'
        word = 'Page changed to draft'
      }
      this.$axios.patch(`/store/settings/${this.company.slug}/pages/${this.page.slug}/`, { status: status})
        .then(() => {
          this.showMessage(['success', word])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .link-preview{
    font-size: 0.9em;
  }
</style>

<i18n>
{
  "en": {
    "delete_page_confirmation": "Are you sure you want to delete this page? This page will be deleted permanently."
  },
  "id": {
    "delete_page_confirmation": "Anda yakin ingin menghapus halaman ini? Halaman ini akan dihapus secara permanen."
  }
}
</i18n>
